import React from "react";
const CustomSpinner = () => {
  return <span className="loader"></span>;
};

export default CustomSpinner;
